import { parseDndData } from '../utils/parsers';

const parserMap = {
  parseDndData: parseDndData,
};

const interceptor = (response) => {
  const API_KEY = response.config.apiKey;
  return parserMap[API_KEY](response);
};

export default interceptor;
